import SimpleCardVertical from "./SimpleCardVertical";

export default SimpleCardVertical;
